import React from "react";
import {renderMarkdownWithInterpolation} from "../../markdown/markdown-factory";
import {inject, observer} from "mobx-react";
import {TEMPLATE_CONSTANTS} from "../../markdown";
import {QD_Default} from "../../markdown/query-summary/templates";
import {
  MDCollapsibleList,
  MDCollapsibleText
} from "../results-grid/grid-row/MDCollapsibleContent";
import EntityView from "../EntityView";

const QueryDetails = ({
  entity,
  markText = null,
  templates,
  expandAliases,
  onAliasesToggle,
  searchSessionStore: { datasets }

}) => {
  // Extract encoding from entity - check smiles/inchi fields first, then extract from ID if needed
  const getEncoding = () => {
    if (entity.smiles || entity.inchi) {
      return entity.smiles || entity.inchi;
    }
    // If ID starts with "smiles:" or "query:", extract the SMILES string
    if (entity.id?.match(/^(smiles|query):/i)) {
      return entity.id.replace(/^(smiles|query):/i, '');
    }
    return null;
  };

  return (
    <div className="query-details" >
      {renderMarkdownWithInterpolation({
                                         templateType: TEMPLATE_CONSTANTS.QUERY_DETAILS,
                                         templates,
                                         templateOverrides: {
                                           Entity: {
                                             component: EntityView,
                                             props: {
                                               showLabel: true,
                                               scale: "lg",
                                               dataset: datasets[entity.dataset],
                                               labelOrientation: "column",
                                               encoding: getEncoding(),
                                               enableOverlay: false
                                             }
                                           },
                                           Text: {
                                             component: MDCollapsibleText
                                           },
                                           List: {
                                             component: MDCollapsibleList,
                                             props: {isOpen: expandAliases, onToggle: onAliasesToggle},
                                           },
                                         },
                                         entity,
                                         markText,
                                         fallback: QD_Default,
                                       })}
    </div>);
}

export default inject("searchSessionStore")(observer(QueryDetails));
